import { IconType } from "react-icons/lib";
import { TbCar, TbChecks, TbClock } from "react-icons/tb";

import { HotelClinicStatus } from "@/models/hotel-clinic.model";

import { softColors } from "./colors";

export type HotelClinicStatusItem = {
    status: HotelClinicStatus;
    component: () => IconType;
    bg: string;
    hover: string;
    /** Shown on chips / timeline */
    label: string;
    /** Shown on “change status” action buttons */
    updateActionLabel: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
};

export const hotelClinicStatusItems: HotelClinicStatusItem[] = [
    {
        status: HotelClinicStatus.PENDING,
        component: () => TbClock,
        ...softColors.amber,
        label: "hotelClinicStatuses.PENDING",
        updateActionLabel: "hotelClinicStatuses.UPDATE_TO_PENDING",
        tooltip: {
            title: "hotelClinicStatuses.PENDING",
            description: "hotelClinicStatuses.PENDING_DESC",
        },
    },
    {
        status: HotelClinicStatus.IN_TRANSIT,
        component: () => TbCar,
        ...softColors.blue,
        label: "hotelClinicStatuses.IN_TRANSIT",
        updateActionLabel: "hotelClinicStatuses.UPDATE_TO_IN_TRANSIT",
        tooltip: {
            title: "hotelClinicStatuses.IN_TRANSIT",
            description: "hotelClinicStatuses.IN_TRANSIT_DESC",
        },
    },
    {
        status: HotelClinicStatus.DONE,
        component: () => TbChecks,
        ...softColors.green,
        label: "hotelClinicStatuses.DONE",
        updateActionLabel: "hotelClinicStatuses.UPDATE_TO_DONE",
        tooltip: {
            title: "hotelClinicStatuses.DONE",
            description: "hotelClinicStatuses.DONE_DESC",
        },
    },
];
